var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitutionPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32099 11.2227H13.679L14.6667 12.7041H1.33334L2.32099 11.2227Z",
    fill: "#9097A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58025 5.29695L7.99981 2.33398L14.4198 5.29695H1.58025Z",
    fill: "#9097A3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.74069,
    y: 6.28516,
    width: 1.48148,
    height: 3.95062,
    fill: "#9097A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.81489,
    y: 6.28516,
    width: 1.48148,
    height: 3.95062,
    fill: "#9097A3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7038,
    y: 6.28516,
    width: 1.48148,
    height: 3.95062,
    fill: "#9097A3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.77802,
    y: 6.28516,
    width: 1.48148,
    height: 3.95062,
    fill: "#9097A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionPlaceholderIcon);
export default __webpack_public_path__ + "static/media/institution-placeholder-icon.e7e38d3d866ae865f03f3482a33816b8.svg";
export { ForwardRef as ReactComponent };